import React from "react";
import { Line, Rect } from "react-konva";

export default function WallColumnNone({
    position,
    lanterns,
    colorList,
    luminaires,
    props,
    barCenter,
    rotateAround,
    centerOffset,
    barThickness,
}) {
    return lanterns.map((lantern, idx) => {
        const offset = (parseFloat(lantern.offset) || 0) - centerOffset;

        const luminaireIndex = luminaires.indexOf(lantern.luminaireId);
        const resolvedColor =
            luminaireIndex !== -1 && colorList[luminaireIndex]
                ? colorList[luminaireIndex]
                : "lightgray";

        const fullArmLength = 0.75;
        const outreach = props.values.useLanternOutreach ? lantern.outreach : props.values.outreach || 0;
        const effectiveArmLength = fullArmLength * Math.max(1, outreach);
        const rectArmLength = fullArmLength * Math.max(0, outreach);

        const armX = offset;
        const armY = -barThickness / 2;
        const armTipX = armX;
        const armTipY = armY - effectiveArmLength;
        const rectX = armX;
        const rectY = armY - rectArmLength;

        const angle = props.positionAngle || 0;
        const angleRad = (angle * Math.PI) / 180;

        const baseRot = rotateAround({ x: barCenter.x + armX, y: barCenter.y + armY }, barCenter, angleRad);
        const armTipRot = rotateAround({ x: barCenter.x + armTipX, y: barCenter.y + armTipY }, barCenter, angleRad);
        const rectRot = rotateAround({ x: barCenter.x + rectX, y: barCenter.y + rectY }, barCenter, angleRad);

        return (
            <React.Fragment key={idx}>
                <Line
                    points={[baseRot.x, baseRot.y, armTipRot.x, armTipRot.y]}
                    stroke={resolvedColor === '#212529' ? "lightgray" : resolvedColor}
                    strokeWidth={0.1}
                />
                <Rect
                    x={rectRot.x}
                    y={rectRot.y}
                    width={0.2}
                    height={0.2}
                    fill={resolvedColor === '#212529' ? "lightgray" : resolvedColor}
                    rotation={angle}
                    offset={{ x: 0.1, y: 0.1 }}
                />
            </React.Fragment>
        );
    });
}
